import React, { useEffect, useRef, useState } from 'react';
import { styles } from './Bubble.css';
import { BubbleArrow } from './BubbleArrow';
import { palette } from '@jbhi-fi/lanyard-ui/themes';

const CARET_WIDTH = 8; // px

export type BubbleType = {
  elementClass: string;
  position: string;
  offset: number;
  variant: string;
  text: string;
  mobile: string;
  isArrowHidden: boolean;
  distance: number;
};

interface NewBubbleProps {
  position: string;
  offset: number;
  variant: string;
  text: string;
  mobile: string;
  isArrowHidden: boolean;
  distance: number;
  onClick: () => void;
}

export const Bubble = ({
  position,
  offset,
  variant,
  onClick,
  text,
  mobile,
  distance,
  isArrowHidden,
}: NewBubbleProps) => {
  const ref = useRef<HTMLHeadingElement>(null);
  const [shouldHide, setShouldHide] = useState(false);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const backgroundColor =
    variant === 'green' ? palette.success.main : variant === 'red' ? palette.error.main : palette.primary.light;
  const margin = `calc(100% + ${distance}px)`;

  const marginOffset = (offsetValue: number) => `calc(50% - ${offsetValue / 2}px + ${offset}px)`;
  const getLeftMargin = (margin: string, width: number) => {
    if (position === 'right') return margin;
    if (position === 'above' || position === 'below') return marginOffset(width);
    return 'auto';
  };
  const getRightMargin = (margin: string, height: number) => {
    if (position === 'below') return margin;
    if (position === 'right' || position === 'left') return marginOffset(height);
    return 'auto';
  };

  const containerStyle: React.CSSProperties = {
    backgroundColor,
    left: getLeftMargin(margin, width),
    right: position === 'left' ? margin : 'auto',
    top: getRightMargin(margin, height),
    bottom: position === 'above' ? margin : 'auto',
  };
  const updateDimensions = () => {
    const newWidth = ref.current ? ref.current.offsetWidth : 0;
    const newHeight = ref.current ? ref.current.offsetHeight : 0;
    if (newWidth !== width || newHeight !== height) {
      setWidth(newWidth);
      setHeight(newHeight);
    }
  };

  useEffect(() => {
    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  const classNames = `${styles.container} ${
    mobile === 'both' ? '' : mobile === 'mobile' ? styles.containerMobileOnly : styles.containerDesktopOnly
  }`;
  const handleClick = () => {
    setShouldHide(true);
    onClick();
  };
  return !shouldHide ? (
    <div
      className={classNames}
      style={containerStyle}
      ref={ref}
      onClick={handleClick}
      onKeyDown={handleClick}
      role={'button'}
      tabIndex={0}
    >
      {text}
      {!isArrowHidden ? (
        <BubbleArrow position={position} backgroundColor={backgroundColor} caretWidth={CARET_WIDTH} />
      ) : null}
    </div>
  ) : null;
};
